const formTemplateType = {
    INVALID : 0,

    APPLICATION : 1,

    RATING : 2,

    QUOTING : 3,

    PRE_QUALIFICATION_INPUT : 4,

    DECLINATION_LETTER : 5,

    EXTERNAL_DATA_REPORT_WCIRB : 6,

    UNDERWRITING_AUTHORITY : 7,

    UNDERWRITING_WORKSHEET : 9,

    LOST_LETTER : 10,

    PREDICTIVE_ANALYTICS : 11,

    NON_RENEWAL_LETTER : 12,

    AGENCY_BROKERAGE_AUTHORITY : 13,

    CORRESPONDENCE : 14,

    AGENT_RATING : 15,

    AGENT_BINDING : 16,

    UNDERWRITER_BINDING : 18,

    ISSUANCE : 19,

    PRE_QUALIFICATION_OUTPUT : 20,

    CARRIER_AUTHORITY : 21,

    ACCOUNT_OVERVIEW : 22,

    ACCOUNT_WORKSHEET : 24,

    EXTERNAL_DATA_REPORT_DNB : 25,

    EXTERNAL_DATA_REPORT_NCCI : 26,

    EXTERNAL_DATA_REPORT_RISK_METER : 27,

    POLICY_FORM : 28,

    ENDORSEMENT_ISSUANCE : 29,

    REJECTION_LETTER : 31,

    PROPOSAL_BINDER_SECTION : 32,

    REWRITE_REISSUE_ISSUANCE : 33,

    PRICING : 34,

    EXTERNAL_DATA_REPORT_EXPERIAN : 35,

    EXTERNAL_DATA_REPORT_EXPERIAN_PREMIER_PROFILE : 36,

    EXTERNAL_DATA_REPORT_VALEN : 37,

    CANCELLATION : 38,

    SUBMISSION : 39,

    EXTERNAL_DATA_REPORT_ISO_PASSPORT : 40,

    ENDORSEMENT : 41,

    USER : 42,

    ORGANIZATION : 43,

    DECLINATION : 44,

    MARK_AS_LOST : 45,

    REWRITE_REISSUE : 46

};

angular.module('gw-um-j2js')
    .constant('formTemplateType', formTemplateType);